var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"fixed inset-0 z-100 bg-white flex flex-col items-center justify-center"},[_c('p',{staticClass:"font-nunito font-bold text-lg"},[_vm._v("Something went wrong...")]),_c('p',{staticClass:"font-nunito font-bold text-xs"},[_vm._v("Error: Missing "),_c('code',[_vm._v("uid")]),_vm._v(" query parameter")])])
}]

export { render, staticRenderFns }